export const LOCATION_MAP_KEYS = new Set([
  "locations",
  "exclude_locations",
  "job_locations",
  "job_exclude_locations",
  "company_locations",
  "company_exclude_locations",
  "people_locations",
  "exclude_people_locations",
  "advertisement_target_locations",
  "advertisement_exclude_target_locations",
]);

const UNSUPPORTED_JOB_LOCATION_OPERATOR_KEYS = new Set([
  "job_locations",
  "job_exclude_locations",
]);

export function locationListToMap(list = []) {
  return new Map(
    list.map(({ value, label }) => [value, { value, label: label || value }]),
  );
}

export function withoutUnsupportedJobLocationOperators(conditions = []) {
  if (!Array.isArray(conditions)) return [];
  return conditions.filter(
    (condition) =>
      !UNSUPPORTED_JOB_LOCATION_OPERATOR_KEYS.has(condition?.key),
  );
}
